{
  "name": "@replit/vite-plugin-dev-banner",
  "version": "0.1.0",
  "private": false,
  "devDependencies": {
    "@replit/tsconfig": "workspace:*",
    "@types/node": "^22.5.5",
    "@typescript-eslint/eslint-plugin": "^6.7.0",
    "@typescript-eslint/parser": "^6.7.0",
    "tsup": "^8.3.5",
    "tsx": "^4.9.5",
    "vite": "^5.4.10"
  },
  "main": "./src/index.ts",
  "files": [
    "src"
  ],
  "scripts": {
    "build": "tsup",
    "lint": "eslint src",
    "format": "prettier --write \"src/**/*.ts\""
  },
  "dependencies": {}
}
